import axios from 'axios';
import { dashedDate } from '@/js/utils/dateTimeUtils';
import type { MergedOfferItemData, AlternativeFlightsRequest, AlternativeFlightsDataArray } from '@interfaces/offer';
import type { SearchFormDataType } from '@interfaces/search-form';
import type { OfferListTypoHotelData } from '@interfaces/offer-list-types/offer-list-typo-hotel-data';
import request from './request';

export const fetchAlternativeFlights = async (
	offerData: MergedOfferItemData,
	hotelData: OfferListTypoHotelData,
	formData: SearchFormDataType
): Promise<AlternativeFlightsDataArray | false> => {
	try {
		const startDateObj = new Date(offerData.StartDate);
		const endDateObj = new Date(offerData.EndDate);

		const alternativeFlightRequestParams: AlternativeFlightsRequest = {
			CurrencyCode: offerData.CurrencyCode,
			HotelIffCode: hotelData.Hotel.IffCode,
			StartDate: dashedDate(startDateObj),
			EndDate: dashedDate(endDateObj),
			MinDuration: offerData.duration,
			MaxDuration: offerData.duration,
			Adults: formData.travelers.adult,
			Children: formData.travelers.children,
			DepartureAirport: offerData.InboundFlight!.Arrival.AirportCode.split('***'),
			DestinationAirport: offerData.InboundFlight!.Departure.AirportCode.split('***'),
			DirectFlight: formData.directFlight,
			OfferCode: offerData.OfferCode,
			RoomCode: offerData.unverifiedRoomCode ?? '',
			BoardType: offerData.unverifiedBoardType ?? '',
			TourOperatorCode: offerData.TourOperator.Code,
		};

		const response = await request<AlternativeFlightsDataArray>({
			method: 'POST',
			url: '/v1/alternative-flights',
			data: alternativeFlightRequestParams,
		});

		if (response && response.Offers && response.Offers.length >= 1) {
			// Remove the current offer from alternatives if it's included
			if (response.Offers[0].OfferID === offerData.OfferID) {
				response.Offers.splice(0, 1);
			}

			// Return the alternatives if there are any left
			if (response.Offers.length >= 1) {
				return response;
			}
		}

		return false;
	} catch (error) {
		if (!axios.isCancel(error as Error)) {
			console.error('Error fetching alternative flights:', error);
		}
		return false;
	}
};

export default {
	fetchAlternativeFlights,
};
